<template>
  <svg class="text-primary" xmlns="http://www.w3.org/2000/svg" width="53" height="16" viewBox="0 0 53 16">
    <g transform="translate(-14307 2581)">
      <rect width="53" height="16" rx="8" transform="translate(14307 -2581)" fill="#fff"/>
      <circle cx="4" cy="4" r="4" transform="translate(14317 -2577)" fill="#21155a"/>
      <circle cx="4" cy="4" r="4" transform="translate(14330 -2577)" fill="#d3ccf1"/>
    </g>
    <circle id="Elipse_35-3" data-name="Elipse 35" cx="4" cy="4" r="4" transform="translate(36 4)" class="fill-current"/>
  </svg>
</template>
